export default __webpack_public_path__ + "static/media/template_7_new.50b53841.png";